/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_OverlineInputs */

const en_mk_agent_3_overline = /** @type {(inputs: Mk_Agent_3_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to it`)
};

const id_mk_agent_3_overline = /** @type {(inputs: Mk_Agent_3_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajak bicara`)
};

/**
* | output |
* | --- |
* | "Talk to it" |
*
* @param {Mk_Agent_3_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_overline = /** @type {((inputs?: Mk_Agent_3_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_overline(inputs)
	return en_mk_agent_3_overline(inputs)
});